import { Stack } from '@leroy-merlin-br/backyard-react'

import { AlertMessage } from 'shared/components'

import * as S from './styled'

interface PriceTagUnavailableProps {
  hidePrice: boolean
  isAssistedSale: boolean
}

const PriceTagUnavailable = ({
  hidePrice,
  isAssistedSale
}: PriceTagUnavailableProps) => {
  const isPriceless = hidePrice && isAssistedSale
  const isProductUnavaliable = !hidePrice || !isAssistedSale

  const title = isPriceless ? 'Produto sem preço :(' : 'Produto indisponível'

  return (
    <Stack space="giga">
      <S.Title>{title}</S.Title>

      {isProductUnavaliable && (
        <AlertMessage type="warning" customIcon="">
          No momento, não temos esse produto disponível em nossos estoques.
        </AlertMessage>
      )}
    </Stack>
  )
}

export default PriceTagUnavailable
